// ============================================
// COSMIC HINDU - Auth Service
// ============================================

import api from './api';

const TOKEN_KEY = 'ch_admin_token';
const LEGACY_TOKEN_KEY = 'admin_token';
const USER_KEY  = 'ch_admin_user';

const authService = {
  async login(email, password) {
    const res = await api.post('login.php', { email, password });
    if (res.success && res.token) {
      localStorage.setItem(TOKEN_KEY, res.token);
      localStorage.setItem(LEGACY_TOKEN_KEY, res.token);
      localStorage.setItem(USER_KEY, JSON.stringify(res.user));
    }
    return res;
  },

  async logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(LEGACY_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    return { success: true };
  },

  async getProfile() {
    try {
      const res = await api.get('verify-token.php');
      if (res.success && res.user) {
        localStorage.setItem(USER_KEY, JSON.stringify(res.user));
        return res.user;
      }
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(LEGACY_TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    }
    return null;
  },

  getStoredToken() { return localStorage.getItem(TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY); },
  getStoredUser()  { try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; } },
  isLoggedIn()     { return !!authService.getStoredToken(); },
};

export default authService;
